// @core/api/endpoints/billing/get_usage_summary.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUsageSummaryResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get usage summary
 * Returns an aggregated summary of usage for a billing account over the specified period, grouped by usage type.
 */
export async function GetUsageSummary(
  params?: {
    billing_account_id?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
    usage_type?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetUsageSummaryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/usage/summary`;
  const requestOptions = options;
  return client.get<GetUsageSummaryResponse>(requestPath, { ...requestOptions, params });
}
